<div class="input-wrapper" [style.height]="errorIsAbsolute ? '48px' : '64px'">
    <div class="input-container" [class.focused]="isFocused" [class.hasError]="errorString">
        <input
            #inputRef
            type="text"
            class="input"
            [(ngModel)]="inputValue"
            (focus)="inputFocus()"
            (blur)="inputBlur()"
            (ngModelChange)="handleChange()"
            [maxlength]="maxlength"
            [placeholder]="placeholder | translate" />
        <ng-container *ngIf="rightText">
            <div class="right-text">{{ rightText | translate }}</div>
        </ng-container>
        <ng-container *ngIf="icon"></ng-container>
    </div>

    <div class="error-message" [class.errorIsAbsolute]="errorIsAbsolute">
        <div *ngIf="errorString">{{ errorString }}</div>
    </div>
</div>
